<template>
    <div>
        <app-sub-title :text="`Gestión documental`" />
        <b-row>
            <b-col>
                <app-file-management-filters
                    @filter="onFilter"
                ></app-file-management-filters>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <app-file-management-list
                    :data="data"
                    @change-page="changePage"
                    @sort="onSort"
                />
            </b-col>
        </b-row>
    </div>
</template>

<script>
import FileManagementList from '../../Administrative/FileManagement/FileManagementList'
import FileManagementFilters from '../../Administrative/FileManagement/FileManagementFilters'
export default {
    components: {
        appFileManagementList: FileManagementList,
        appFileManagementFilters: FileManagementFilters,
    },
    data() {
        return {
            data: [],
            page: 1,
            selectVenue: '',
            filters: {},
            sort: {
                sortBy: 'name',
                sortDir: 'asc',
            },
        }
    },
    methods: {
        onFilter(filters) {
            this.filters = filters
            this.loadFiles()
        },
        async loadFiles() {
            const filters = {
                ...this.filters,
                sortBy: this.sort.sortBy,
                sortDir: this.sort.sortDir,
                clientId: this.client.id,
                clientAdmin: true,
            }

            const { data } = await repo.get(
                'file-management',
                filters,
                'Lo sentimos, ha ocurrido un error'
            )
            this.data = data
        },
        changePage(page) {
            this.page = page
            this.loadFiles()
        },
        onSort(ctx) {
            this.sort.sortBy = ctx.sortBy
            this.sort.sortDir = ctx.sortDir
            this.loadFiles()
        },
    },
    created() {
        this.loadFiles()
    },
}
</script>

<style></style>
